import styles from "./award.module.css"
import Link from "next/link";
import RichText from "../richText/richText";

export default function Award({id, image, title, subtitle, products, description}){
    function showPopup() {
        let blog = document.getElementById(`awardPopup-${id}`);
            blog.classList.add("showFlex");
            
    }
    function hidePopup() {
        let blog = document.getElementById(`awardPopup-${id}`);
        if(blog.classList.contains("showFlex"))
            blog.classList.remove("showFlex");
        else{
            blog.style.display = "none";
        }
    }

    function initProducts(){
        const rows =[];
        products.forEach(product => {
                rows.push(
                    <div className="start">
                        <Link href={`/weinkauf/shop/details/?id=${product.product.header.productHeaderId}`}><p className="underline link uppercase">{product.product.header.name} {product.product.header.klassifikation} {product.product.vintage != null && product.product.vintage.split("-")[0]}</p></Link>
                        <p>{product.description}</p>
                        <p>{product.additionalInfos}</p>
                    </div>
                )
        });
        return rows;
    }
    return(
        <>
            <div className={styles.container} onClick={() => showPopup()}>
                <img alt={title || "Auszeichnung"} src={image} style={{maxWidth:"250px", cursor:"pointer"}}/>
            </div>
            <div id={`awardPopup-${id}`} className={styles.overlay}>
                <div className={styles.popup}>
                    <p className="uppercase annotation" style={{cursor:"pointer"}} onClick={() => hidePopup()}>X Schliessen</p>
                    <img alt={title || "Auszeichnung"} src={image} style={{maxHeight:"200px"}}/>
                    <h2 className="center-text">{title}</h2>
                    <p className="annotation brown center-text"><q>{subtitle}</q></p>
                    <RichText html={description} className="center-text"/>

                    {products && initProducts()}
                </div>
            </div>
        </>
    )
}